// src/Redux/slices/bmiHistorySlice.js
import { createSlice } from "@reduxjs/toolkit";
import {
  fetchBmiHistoryByUserId,
  addBmiEntry,
  updateBmiEntry,
} from "../thunks/bmiHistoryThunks";

const initialState = {
  data: [],          // [{ id, userId, poidsKg, tailleCm, imc, date }]
  loading: false,
  error: null,
  hasFetched: false,
};

const sortByDateAsc = (arr) =>
  arr.slice().sort((a, b) => new Date(a?.date || 0) - new Date(b?.date || 0));

const replaceById = (arr, rec) => {
  if (!rec?.id) return arr;
  const next = arr.slice();
  const idx = next.findIndex((x) => x.id === rec.id);
  if (idx !== -1) next[idx] = rec;
  return next;
};

const bmiHistorySlice = createSlice({
  name: "bmiHistory",
  initialState,
  reducers: {
    clearBmiHistoryError: (state) => {
      state.error = null;
    },
    resetBmiHistory: () => ({ ...initialState }),
  },
  extraReducers: (builder) => {
    builder
      // ---- FETCH ----
      .addCase(fetchBmiHistoryByUserId.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchBmiHistoryByUserId.fulfilled, (state, action) => {
        state.loading = false;
        state.data = Array.isArray(action.payload)
          ? sortByDateAsc(action.payload)
          : [];
        state.hasFetched = true;
      })
      .addCase(fetchBmiHistoryByUserId.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
        state.hasFetched = true;
      })

      // ---- ADD (POST) ----
      .addCase(addBmiEntry.pending, (state) => {
        state.error = null;
      })
      .addCase(addBmiEntry.fulfilled, (state, action) => {
        const rec = action.payload;
        if (rec) {
          state.data = sortByDateAsc([...(state.data || []), rec]);
        }
      })
      .addCase(addBmiEntry.rejected, (state, action) => {
        state.error = action.payload;
      })

      // ---- UPDATE (PUT) ----
      .addCase(updateBmiEntry.pending, (state) => {
        state.error = null;
      })
      .addCase(updateBmiEntry.fulfilled, (state, action) => {
        const rec = action.payload;
        if (rec) {
          state.data = sortByDateAsc(replaceById(state.data || [], rec));
        }
      })
      .addCase(updateBmiEntry.rejected, (state, action) => {
        state.error = action.payload;
      });
  },
});

export const { clearBmiHistoryError, resetBmiHistory } = bmiHistorySlice.actions;
export default bmiHistorySlice.reducer;
